import React, { Fragment } from 'react';
import { get } from 'lodash-es';
import { Col, FormGroup, Input, Label, Row, UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const InvoiceSettings = ({
  groupSettings,
  handleInvoiceChange,
  validation,
  validateEmail,
  validateRequired
}) => {
  if (!groupSettings) {
    return null;
  }

  return (
    <Fragment>
      <h3 className="mt-5">Invoice Email Settings</h3>

      <FormGroup>
        <Label for="subject" className="font-weight-bold mb-0">
          Email Subject*
        </Label>
        <Input
          className={get(validation, 'subject') ? 'is-invalid' : ''}
          id="subject"
          maxLength="150"
          name="Email Subject"
          onBlur={e => validateRequired(e)}
          onChange={e => handleInvoiceChange(e)}
          type="text"
          value={get(groupSettings, 'subject', '')}
        />
        {get(validation, 'subject') && <p className="color-danger my-0">{validation.subject}</p>}
      </FormGroup>

      <Row className="mt-4">
        <Col>
          <FormGroup>
            <Label for="fromName" className="font-weight-bold mb-0">
              Reply To Name*
            </Label>
            <Input
              className={get(validation, 'fromName') ? 'is-invalid' : ''}
              id="fromName"
              maxLength="150"
              name="Reply To Name"
              onBlur={e => validateRequired(e)}
              onChange={e => handleInvoiceChange(e)}
              type="text"
              value={get(groupSettings, 'fromName', '')}
            />
            {get(validation, 'fromName') && (
              <p className="color-danger my-0">{validation.fromName}</p>
            )}
          </FormGroup>
        </Col>

        <Col>
          <FormGroup>
            <Label for="fromEmail" className="font-weight-bold mb-0">
              Reply To Email*
            </Label>
            <Input
              className={get(validation, 'fromEmail') ? 'is-invalid' : ''}
              id="fromEmail"
              maxLength="150"
              name="Reply To Email"
              onBlur={e => { validateEmail(e); validateRequired(e); }}
              onChange={e => handleInvoiceChange(e)}
              type="text"
              value={get(groupSettings, 'fromEmail', '')}
            />
            {get(validation, 'fromEmail') && (
              <p className="color-danger my-0">{validation.fromEmail}</p>
            )}
          </FormGroup>
        </Col>

        <Col>
          <FormGroup>
            <Label for="bccEmail" className="font-weight-bold mb-0">
              BCC &nbsp;
              <FontAwesomeIcon id="bccEmailIcon" className="color-blue" icon="question-circle" />
            </Label>
            <UncontrolledTooltip placement="right" target="bccEmailIcon">
              A copy of your invoices will be sent to this email address.
            </UncontrolledTooltip>
            <Input
              className={get(validation, 'bccEmail') ? 'is-invalid' : ''}
              type="text"
              id="bccEmail"
              maxLength="150"
              onBlur={e => validateEmail(e)}
              onChange={e => handleInvoiceChange(e)}
              value={get(groupSettings, 'bccEmail', '')}
            />
            {get(validation, 'bccEmail') && (
              <p className="color-danger my-0">{validation.bccEmail}</p>
            )}
          </FormGroup>
        </Col>
      </Row>
    </Fragment>
  );
};

export default InvoiceSettings;
